import React from 'react';

import styled from 'styled-components';

import SizeSelectionExpansionPanel from '~/shared/components/SizeSelectionExpansionPanel';
import SizeSelectionContent from '~/shared/components/SizeSelectionExpansionPanel/components/SizeSelectionContent';

const SizingFormWrapper = styled.div`
  ${SizeSelectionContent.SizingGrid} {
    ${({ theme }) => theme.promoPickerPopup.sizingGrid}
  }
`;

export default function SizingForm() {
  return (
    <SizingFormWrapper data-autotag="SizingForm__SizingFormWrapper">
      <SizeSelectionExpansionPanel />
    </SizingFormWrapper>
  );
}
